import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    model: null,
    // cityName: "Tarragona",
    cityName: "",
    mapPosition: [41.119155, 1.245412], // Default position for Tarragona
    modelSize: "yolo11n",
    isLoading: false,
    // message: "Tarragona || yolo11n Model Loading...",
    message: "",
    currentModelSize: null,
    currentCityName: null,
};

const modelSlice = createSlice({
    name: "model",
    initialState,
    reducers: {
        setModel: (state, action) => {
            state.model = action.payload;
            state.message = `✅ ${state.cityName} || ${state.modelSize} Model loaded Successfully...`;
            state.isLoading = false; // Set loading state to true
        },
        setCityName: (state, action) => {
            const cityName = action.payload;
            if (cityName === "Reus") {
                state.mapPosition = [41.149877, 1.105463];
            } else if (cityName === "Lleida") {
                state.mapPosition = [41.616134, 0.620782];
            } else {
                state.mapPosition = [41.119155, 1.245412]; // Default position for Tarragona
            }
            state.cityName = action.payload;
        },
        setModelSize: (state, action) => {
            state.modelSize = action.payload;
        },
        setCurrentCityName: (state, action) => {
            state.currentCityName = action.payload;
        },
        setCurrentModelSize: (state, action) => {
            state.currentModelSize = action.payload;
        },
        setIsLoading: (state, action) => {
            if (action.payload) { // Check if payload is a boolean
                state.isLoading = action.payload;
                state.message = action.payload;
            } else { // If payload is not a boolean, reset to false
                state.isLoading = action.payload;
            }
        },
        setMessage: (state, action) => {
            state.message = action.payload;
        },
        
    }
});

export const {
    setModel,
    setModelSize,
    setCurrentModelSize,
    setIsLoading,
    setCityName,
    setMessage,
    setCurrentCityName,
} = modelSlice.actions;

export default modelSlice.reducer;